/**
 * @since 2024-06-01
 * @author Francesco Parrella
 * @maintainer Francesco Parrella
 * @copyright AlgoTraders, All rights reserved
 */

import TableWithPagination from "components/Shared/TableWithPagination";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { toFloat } from "utils/formatting";
import { parseNumber } from "utils/parsing";

const ItemTableCorrelations = ({ itemData }) => {
  const intl = useIntl();
  const [dataTable, setDataTable] = useState(null);

  const columns = [
    {
      title: "Benchmark",
      dataIndex: "index",
      key: "index",
      sorter: (a, b) => a.index.localeCompare(b.index),
      showSorterTooltip: false,
    },
    {
      title: "Correlation",
      dataIndex: "correlation",
      key: "correlation",
      align: "right",
      tooltip: intl.formatMessage({
        id: "reports-benchmark-correlation",
      }),
      sorter: (a, b) => parseNumber(a.correlation) - parseNumber(b.correlation),
      showSorterTooltip: false,
    },
    {
      title: "Alpha",
      dataIndex: "alpha",
      key: "alpha",
      tooltip: intl.formatMessage({
        id: "reports-benchmark-alpha",
      }),
      align: "right",
      sorter: (a, b) => parseNumber(a.alpha) - parseNumber(b.alpha),
      showSorterTooltip: false,
    },
    {
      title: "Beta",
      dataIndex: "beta",
      key: "beta",
      tooltip: intl.formatMessage({
        id: "reports-benchmark-beta",
      }),
      align: "right",
      sorter: (a, b) => parseNumber(a.beta) - parseNumber(b.beta),
      showSorterTooltip: false,
    },
  ];

  useEffect(() => {
    if (itemData === null) return;
    setDataTable(convertToAntTableData(itemData));
  }, [itemData]);

  function convertToAntTableData(data) {
    return data.Index.map((indexName, rowIndex) => {
      let tableItem = {
        key: rowIndex,
        index: indexName,
        correlation: toFloat(itemData.Values[rowIndex][0]),
        alpha: toFloat(itemData.Values[rowIndex][1]),
        beta: toFloat(itemData.Values[rowIndex][2]),
      };
      return tableItem;
    });
  }

  return (
    <div style={{ width: "50%", maxWidth: "800px" }}>
      <TableWithPagination dataTable={dataTable} columns={columns} />
    </div>
  );
};
export default ItemTableCorrelations;
